<template>
  <div id="notification_invite_holder">
    <notification-pop-up-item
      v-for="notification in notificationsPopup"
      :ref="'nt_' + notification"
      :key="notification"
      :notification="notification"
      :transform="notificationsTransform[notification]"
    />
  </div>
</template>

<script>
import { component } from '../../mixins/component';
import { NotificationMixin } from '../../mixins/notification';
import NotificationPopUpItem from './popups/NotificationPopUpItem';
const _cloneDeep = require('lodash.clonedeep');

export default {
  components: { NotificationPopUpItem },
  mixins: [component, NotificationMixin],
  data() {
    return {
      notificationsTransform: {},
    };
  },
  computed: {
    notificationsPopup() {
      return _cloneDeep(this.$store.state.notifications.notifications_popup);
    },
  },
  watch: {
    notificationsPopup: function(newVal, oldVal) {
      this.updateNotificationTransform(newVal, oldVal);
    },
  },
  created() {},
  methods: {
    updateNotificationTransform(newVal, oldVal) {
      if (newVal.length > oldVal.length) {
        let offset = 0;
        if (oldVal.length > 0) {
          offset = this.$refs['nt_' + oldVal[0]][0].getHeight() + 10;
        }
        const newTransform = {};
        for (let i = 0; i < newVal.length; i++) {
          const notification = newVal[i];
          if (i > 0) {
            newTransform[notification] = this.notificationsTransform[notification] + offset;
          } else {
            newTransform[notification] = 0;
          }
        }
        this.notificationsTransform = newTransform;
      }
    },
  },
};
</script>
